import { useMutation, useQueryClient } from "@tanstack/react-query";

import useApiHelper from "../../hooks/useApiHelper";
import { IPendingPartCategory } from "../../models/PendingCategory/PendingCategory";
import { PendingCategoryQueryKeys } from "./keys";
import { CategoryQueryKeys } from "../Category/keys";

export default function usePendingCategoryMutations() {
  const { post, del } = useApiHelper();
  const queryClient = useQueryClient();

  // Confirm & add: promote a pending category into the real part categories.
  const confirm = useMutation({
    mutationFn: (category: IPendingPartCategory) => post(`/part/pending-categories/${category.id}/confirm`, category),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: PendingCategoryQueryKeys.all() });
      queryClient.invalidateQueries({ queryKey: CategoryQueryKeys.all() });
    },
  });

  // Reject: discard a pending category without adding it (soft delete).
  const remove = useMutation({
    mutationFn: (pendingCategoryId: string) => del(`/part/pending-categories/${pendingCategoryId}`),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: PendingCategoryQueryKeys.all() });
    },
  });

  return {
    confirm,
    remove,
  };
}
